import ProfileLocked from "@components/templates/Profile/ProfileLocked";
import IntelLayout from "@components/layout/layout";
import { useState } from "react";

const SampleLogisitcs = () => {
  const [showNotification, setShowNotification] = useState(false);
  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"logisticsProfileLocked"}>
      <ProfileLocked key="Logistics Profile" countries="Intel Enterprise Logistics" heading="View port profile to get deep insights on its Trade Lanes, Logistic Companies working on it along with actual Importers and Exporters details" />
    </IntelLayout>
  );
};

export default SampleLogisitcs;
